<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/segment-icon-org.svg" alt="Segmentos" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Segmentos</h1>
                        <div class="dropdown-wrapper" #dropdownContainer>
                            <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                                <span>{{selectedItem === 'recientes' ? 'Campañas de hoy' : 'Todas las campañas'}}</span>
                                <span [class.rotated]="showRecentDropdown">▼</span>
                                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'todas'" (click)="selectItem('todas')">
                                        <span class="check-icon" *ngIf="selectedItem === 'todas'">✔</span>
                                        Todas las campañas
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'recientes'" (click)="selectItem('recientes')">
                                        <span class="check-icon" *ngIf="selectedItem === 'recientes'">✔</span>
                                        Campañas de hoy
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-actions">
                        <button class="action-btn outline" (click)="openCampaigns()">
                            <img src="assets/svg/campaign-icon-org.svg" alt="Vista resumen" width="16" height="16" />
                            Ver campañas
                        </button>
                        <button class="action-btn primary" (click)="openManageSegmento()">
                            <img src="assets/svg/plus-icon.svg" alt="Añadir nuevo" width="16" height="16" />
                            Nuevo segmento
                        </button>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{campanasFiltradas.length}} elementos | Se actualizó hace 2 minutos</span>
                    <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
                        Filtros aplicados
                        <button (click)="clearFilters()" class="clear-filters-btn">×</button>
                    </span>
                </div>
                <div class="content-area mt-5">
                    <div *ngIf="errorMessage" class="error-message">
                        {{errorMessage}}
                    </div>
                    <div *ngIf="segmentos.length > 0">
                        <div class="d-grid search-bar-container" style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            gap: 16px;
                        ">
                            <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                                <div><img src="assets/svg/search.svg" alt=""></div>
                                <input 
                                    type="text" 
                                    class="npt-nav-search" 
                                    placeholder="Buscar por nombre de campaña, segmento o ejecutivo..."
                                    [(ngModel)]="searchTerm"
                                    (input)="onSearchChange()"
                                    style="flex: 1; min-width: 0; width: 100%"
                                >
                            </div>
                            <div style="display: flex; gap: 12px; flex-shrink: 0">
                                <button class="search-btn" (click)="cargarSegmentos()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/reload-icon.svg" alt="Actualizar">
                                    <span>Actualizar</span>
                                </button>
                                <button class="d-grid search-btn">
                                    <img src="assets/svg/pen-icon.svg" alt="Editar">
                                    <span>Editar</span>
                                </button>
                                <button class="d-grid search-btn" (click)="openMdlCharts()">
                                    <img src="assets/svg/grafic-icon.svg" alt="Gráfica">
                                    <span>Ver gráfico</span>
                                </button>
                                <button class="search-btn" (click)="openFilterModal()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/filtrar-icon.svg" alt="Filtrar">
                                    <span>Filtrar</span>
                                </button>
                            </div>
                        </div>
                        <div class="prospectos-table mh-50">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="checkbox-column text-center">
                                            <img src="assets/svg/checkline-icon.svg">
                                        </th>
                                        <th>
                                            Nombre del segmento
                                        </th>
                                        <th>
                                            Tipo de módulo
                                        </th>
                                        <th>
                                            Fecha creación
                                        </th>
                                        <th>
                                            Última modificación
                                        </th>
                                        <th>
                                            Destinatarios
                                        </th>
                                        <th>
                                            Filtros aplicados
                                        </th>
                                        <th>
                                            Ejecutivo asignado
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of segmentos; let i=index">
                                        <td class="counter-cell">{{ i + 1 }}.</td>
                                        <td class="checkbox-column">
                                            <input type="checkbox" (click)="$event.stopPropagation()">
                                        </td>
                                        <td>{{item.nombre_segmento}}</td>
                                        <td></td>
                                        <td>{{item.created_at | date:'d/mm/y':'':'es'}}</td>
                                        <td>{{item.updated_at | date:'d/mm/y':'':'es'}}</td>
                                        <td>Tipo: {{item.tipo_entidad === "PRO" ? "Prospecto" : "Cuenta"}}</td>
                                        <td class="estado-cell">
                                            <span class="estado-badge estado-{{item.estado?.toLowerCase().replace(' ', '-') || 'activa'}}">
                                                {{item.estado || 'Activa'}}
                                            </span>
                                        </td>
                                        <td>{{item.ejecutivo.nombre}} {{item.ejecutivo.apellido}}</td>
                                        <td class="actions-cell">
                                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + item.id)">
                                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="5" r="2"/>
                                                        <circle cx="12" cy="12" r="2"/>
                                                        <circle cx="12" cy="19" r="2"/>
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + item.id">
                                                    <button class="dropdown-item" (click)="openMdlDeleteCampana(item.campana_id)">Modificar</button>
                                                    <button class="dropdown-item" (click)="openMdlDeleteCampana(item.campana_id)">Usar en nueva campaña</button>
                                                    <button class="dropdown-item" (click)="openMdlDeleteCampana(item.campana_id)">Eliminar segmento</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="!isLoading && segmentos.length === 0 && !errorMessage" class="empty-state">
                        <div class="empty-content">
                            <div class="empty-image">
                                 <img src="assets/img/listaprospecto.png" alt="Lista de campanas vacía" />
                            </div>
                            <h2>Sin segmentos por ahora</h2>
                            <p>Todavía no tienes segmentos registradas. Puedes comenzar agregando uno nuevo.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</div>